import React from 'react';
import { cn } from '@/lib/utils';
import { Radio, RefreshCw, WifiOff } from 'lucide-react';

export type ConnectionStatus = 'LIVE' | 'RECONNECTING' | 'OFFLINE';

interface ConnectionIndicatorProps {
  status: ConnectionStatus;
  reconnectAttempt?: number;
  lastHeartbeat?: string | null;
  className?: string;
}

export const ConnectionIndicator: React.FC<ConnectionIndicatorProps> = ({
  status,
  reconnectAttempt = 0,
  className,
}) => {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 px-2.5 py-1 rounded-md border text-xs font-mono select-none transition-all',
        status === 'LIVE' && 'bg-emerald-950/40 text-emerald-300 border-emerald-800/50',
        status === 'RECONNECTING' && 'bg-amber-950/40 text-amber-300 border-amber-800/50',
        status === 'OFFLINE' && 'bg-slate-900/60 text-slate-400 border-slate-800',
        className
      )}
    >
      {status === 'LIVE' && (
        <>
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
          </span>
          <Radio className="w-3.5 h-3.5 text-emerald-400" />
          <span className="font-semibold tracking-wider">WS LIVE</span>
        </>
      )}

      {status === 'RECONNECTING' && (
        <>
          <RefreshCw className="w-3.5 h-3.5 text-amber-400 animate-spin" />
          <span className="font-semibold tracking-wider">
            RECONNECTING {reconnectAttempt > 0 ? `(#${reconnectAttempt})` : ''}
          </span>
        </>
      )}

      {status === 'OFFLINE' && (
        <>
          <WifiOff className="w-3.5 h-3.5 text-slate-400" />
          <span className="font-semibold tracking-wider">WS OFFLINE</span>
        </>
      )}
    </div>
  );
};
